<template>
  <div class="auth-page auth-page--login">
    <div class="auth-page__inner">
      <div class="auth-page__title">{{ $t("otp.title") }}</div>
      <div class="auth-page__sub-title">
        {{ $t("otp.sub_title") }}
      </div>
      <div class="auth-page__fields">
        <div class="auth-page__field">
          <text-input
            :title="$t('registration.registry_identifier')"
            :mask="'TTTTTTTTTTTTTTT'"
            v-model="otpCode"
            ref="otpInput"
            :errors="v$.otpCode.$errors"
            @enterPressed="loginOtp"
            autocomplete="one-time-code"
          ></text-input>
        </div>
      </div>
      <div class="auth-page__actions">
        <primary-button
          class="auth-page__action auth-page__action--half"
          :text="$t('otp.actions.login')"
          @click="loginOtp"
        ></primary-button>
        <transparent-button
          class="auth-page__action auth-page__action--half"
          :text="$t('otp.actions.register')"
        ></transparent-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import TextInput from "@/components/inputs/TextInput";
import { AuthApi } from "@/office/auth/auth-api";
import { mapState } from "vuex";
import { LOGIN_USER } from "@/store/action-types";
import useVuelidate from "@vuelidate/core";
import { helpers, minLength, required } from "@vuelidate/validators";
export default {
  name: "LoginOtpCustom",
  components: { TextInput, TransparentButton, PrimaryButton },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      otpCode: "",
      vuelidateExternalResults: {
        otpCode: "",
      },
    };
  },
  validations() {
    return {
      otpCode: {
        required: helpers.withMessage("otp_code_required", required),
        minLength: helpers.withMessage("otp_incorrect", minLength(4)),
      },
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted() {
    this.$refs.otpInput.focus();
  },
  methods: {
    async loginOtp() {
      const isValid = await this.v$.$validate();

      if (!isValid) {
        return;
      }

      new AuthApi()
        .finishLoginCustom(
          this.user.phone,
          this.otpCode,
          this.user.otpOperationId
        )
        .then(async (r) => {
          await this.$store.dispatch(LOGIN_USER, {
            accessToken: r.data.access_token,
            phone: this.phone,
          });
          this.$router.push("/");
        })
        .catch((err) => {
          Object.assign(this.vuelidateExternalResults, {
            otpCode: err.data.message,
          });

          setTimeout(() => {
            this.v$.$clearExternalResults();
          }, 3000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page {
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;
  }

  &__action {
    &--half {
      width: calc(50% - 5px);
    }
  }
}
</style>
